<template>
  <cms-section v-if="eSpots?.['over-image']" class="mb-4" :section="eSpots?.['over-image']" />
  <error-403 />
  <cms-section v-if="eSpots?.['lazy-main']" class="mb-22 mt-4 md:mb-20" :section="eSpots?.['lazy-main']" />
</template>

<script lang="ts" setup>
const { $feature, $t } = useNuxtApp()
const eSpots = $feature.enable404Espots && (await useCms().getSections.error()).data.value?.content.sectionsMap
useSeoMeta({ title: $t.error, robots: $feature.enableNoindexOnErrorPages ? 'noindex, nofollow' : '' })
</script>
